

































































import { Component, Vue } from "vue-property-decorator";
import { userList } from "@/api/users";
import { User } from "@/api/model/user";
import accountEdit from "./account_edit.vue";

@Component({
  components: { accountEdit },
  name: "rolelist",
  filters: {
    statusFilter: (status: string) => {
      const statusMap: { [key: string]: string } = {
        published: "success",
        draft: "gray",
        deleted: "danger",
      };
      return statusMap[status];
    },
    parseTime: (timestamp: string) => {
      return new Date(timestamp).toISOString();
    },
  },
})
export default class extends Vue {
  private listLoading = true;
  private page = 1;
  private page_size = 10;
  private list: Array<User> = [];
  private total: number = 0;
  private editKey = (new Date()).getTime()+Math.random()
  private search: User = {
    user_name: "",
    nick_name: "",
    role_code: ""
  };
  private editUser=<User>{};
  private showEdit=false
  created() {
    this.initData();
  }
  private async initData(){
    await this.getList()
  }
  private async getList() {
    this.listLoading = true;
    userList(this.search, this.page, this.page_size)
      .then((res) => {
        if (res.list.length > 0) {
          this.list = res.list;
          this.total = res.total;
        }
      })
      .finally(() => {
        this.listLoading = false;
      });
  }
  private pageChange(page: number) {
    this.page = page;
    this.getList();
  }
  private append() {
    this.editUser = <User>{};
    this.showEdit=true;
    this.editKey = (new Date()).getTime()+Math.random()
  }
  private edit(item: User) {
    this.editUser = item;
    this.showEdit=true
    this.editKey = (new Date()).getTime()+Math.random()
  }
  private del(e: User) {
    this.$confirm("此操作将永久删除该权限组, 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }).then(() => {
      this.listLoading = true;
      
    });
  }
  private onSearch(){
    this.page = 1;
    this.getList()
  }
  private close(refresh:boolean){
    this.showEdit=false;
    if(refresh){
      this.getList()
    }
  }
}
